import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';

const CloseLink = styled(Link)`
  display: block;
  padding: 5px;
  margin-left: 40px;
  outline: none;
  color: #fff;
  opacity: 0.6;
  transition: opacity 0.25s ease-out;

  &:hover {
    opacity: 1;
  }
`;

export default CloseLink;
